export const scrollToAnchor = (anchorName) => {
  if (anchorName) {
    // 找到錨點
    let anchorElement = document.getElementById(anchorName);
    // 如果對應id的錨點存在，就跳轉到錨點
    if (anchorElement) {
      anchorElement.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  }
};
